import { useEffect, useState } from "react";
import { fetchDeliveryConfig } from "../services/catalogService";
import {
  DeliveryOption,
  DEFAULT_DELIVERY_OPTIONS,
  buildDeliveryOptions,
} from "../data/deliveryConfig";

// Caché compartida a nivel de módulo para que todas las partes de la web usen la misma config
let sharedOptions: DeliveryOption[] | null = null;
let sharedPromise: Promise<DeliveryOption[]> | null = null;

export const invalidateDeliveryOptions = (newConfig?: any) => {
  if (newConfig) {
    sharedOptions = buildDeliveryOptions(newConfig);
  } else {
    sharedOptions = null;
  }
  sharedPromise = null;
};

export const loadDeliveryOptions = (forceRefresh = false): Promise<DeliveryOption[]> => {
  if (!forceRefresh && sharedOptions) return Promise.resolve(sharedOptions);
  if (!forceRefresh && sharedPromise) return sharedPromise;

  sharedPromise = (async () => {
    try {
      const config = await fetchDeliveryConfig();
      sharedOptions = buildDeliveryOptions(config);
    } catch {
      sharedOptions = DEFAULT_DELIVERY_OPTIONS.map((o) => ({ ...o }));
    } finally {
      sharedPromise = null;
    }
    return sharedOptions;
  })();

  return sharedPromise;
};

export const useDeliveryOptions = (): DeliveryOption[] => {
  const [options, setOptions] = useState<DeliveryOption[]>(
    sharedOptions || DEFAULT_DELIVERY_OPTIONS
  );

  useEffect(() => {
    let mounted = true;
    loadDeliveryOptions().then((opts) => {
      if (mounted) setOptions(opts);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return options;
};